import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, unref as _unref, withDirectives as _withDirectives, mergeProps as _mergeProps, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "col-12 d-flex bd-highlight align-content-center" }
const _hoisted_2 = { class: "card-title p-2 w-100 bd-highlight" }
const _hoisted_3 = { class: "p-2 bd-highlight mt--2 pt--1" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-sync-alt" })
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_6 = { class: "p-2 bd-highlight ml--2 mt--2 h-100" }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("button", { class: "btn btn-white btn-sm my-1" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-ellipsis-v" })
], -1)
const _hoisted_9 = { key: 0 }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-edit mx-1" }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Editar ")
const _hoisted_13 = [
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = { class: "mb--2" }
const _hoisted_15 = { class: "col-12 d-flex justify-content-center justify-content-sm-between flex-wrap mt-3" }
const _hoisted_16 = { class: "" }
const _hoisted_17 = { class: "card-category" }

import { IPagination } from "@/callcenter/omni";
import { IColumn, ITableData, ITablePagination } from "@/types/components";
import { Search, InfoFilled } from "@element-plus/icons-vue";
import {
	ClickOutside as vClickOutside,
	TableProps,
	TableColumnCtx,
} from "element-plus";

export interface Irow {
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	row: any;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	rowIndex: any;
}

import { ref, computed, watch, unref, useSlots, h, onMounted } from "vue";
import { RouteLocationRaw } from "vue-router";
import { useRouter } from "vue-router";

// => Props & emits

export default /*#__PURE__*/_defineComponent({
  props: {
    tableData: null,
    disabled: { type: Boolean },
    tittle: null,
    load: { type: Boolean },
    tittlebtn: null,
    showOptions: { type: Boolean },
    hideDefaultOptions: { type: Boolean },
    btn: null,
    cardClass: null,
    filter: null,
    tableLayout: null,
    selectArray: null,
    select: { type: Boolean },
    defaultSelect: null,
    information: { type: Boolean },
    informationLabel: null,
    pagination: null,
    tableProps: null
  },
  emits: ["edit", "delete", "discount", "event", "updateData", "row-click", "updateInputData"],
  setup(__props: any, { emit: emits }: { emit: ({
	(e: "edit", row: any): void;
	(e: "delete", row: any): void;
	(e: "discount", row: any): void;
	(e: "event", row: any): void;
	(e: "updateData", pag: { pagination: IPagination; typeSelect: any }): void;
	(
		e: "row-click",
		data: { row: any; col: TableColumnCtx<any>; e: PointerEvent }
	): void;
	(
		e: "updateInputData",
		pag: { pagination: IPagination; typeSelect: any }
	): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
	tableData: ITableData;
	disabled?: boolean;
	tittle: string;
	load: boolean;
	tittlebtn?: string;
	showOptions?: boolean;
	hideDefaultOptions?: boolean;
	btn?: any;
	cardClass?: string;
	filter?: any;
	tableLayout?: any;
	selectArray?: { value: string; label: string }[];
	select?: boolean;
	defaultSelect?: string;
	information?: boolean;
	informationLabel?: string;
	pagination?: ITablePagination;
	tableProps?: Partial<TableProps<any>>;
}

// import { HistoryModule } from "@/store/modules/History";
const slots = useSlots();



// => State
const router = useRouter();

// => Computed
const paginationState = {
	perPage: 6,
	currentPage: 1,
	perPageOptions: [6, 10, 25, 50],
	total: 0,
};
const pagination = computed(() => props.pagination ?? paginationState);
const currentPage = ref(1);
const total = computed(() => {
	return props.pagination
		? props.pagination.total
		: props.tableData
		? props.tableData.totalDocs
		: 0;
});
const rawData = computed(() => {
	return props.tableData?.td;
});

const pagedData = computed(() => {
	//return rawData?.value?.slice(from.value, to.value);
	return rawData.value;
});
const from = computed(() => {
	return (
		pagination.value.perPage *
		((props.pagination ? pagination.value.currentPage : currentPage.value) - 1)
	);
});

const to = computed(() => {
	let highBound = from.value + pagination.value.perPage;
	if ((total.value as number) < highBound) {
		highBound = total.value as number;
	}
	return highBound;
});

const model = ref({
	search: "",
	selectValue: props.defaultSelect,
});
const getPag = (page: undefined | number = undefined): IPagination => {
	const pag = {
		page: page ?? currentPage.value,
		limit: pagination.value.perPage,
		filter: model.value.search,
	};
	return pag;
};

const buttonRef = ref();
const popoverRef = ref();

// => Methods
function onChangeLimit(value: number) {
	if (!props.pagination) paginationState.perPage = value;
	const pag = getPag(1);
	pag.limit = value;
	emits("updateData", {
		pagination: pag,
		typeSelect: model.value.selectValue,
	});
}
const onClickOutside = () => {
	if (popoverRef.value) unref(popoverRef).popperRef?.delayHide?.();
};

function ColumnProp({
	scope,
	column,
}: {
	scope: any;
	column: IColumn;
	index: number;
}) {
	if (Object.prototype.hasOwnProperty.call(slots, scope.column.property))
		return h("div", slots[scope.column.property]?.(scope));
	const text = scope.column?.formatter
		? scope.column?.formatter(scope.row, scope.column)
		: scope.row[scope.column.property]
		? scope.row[scope.column.property]
		: column.default
		? column.default
		: "-";
	return column.link
		? h(
				"a",
				{
					href: "#",
					class: "d-flex w-100 text-decoration-none align-items-center me-2",
					onClick(event: PointerEvent) {
						event.preventDefault();
						router.push(column.link as RouteLocationRaw);
					},
				},
				[
					text,
					h("i", {
						class: "fs-8 fas fa-external-link-alt ms-auto",
					}),
				]
		  )
		: text;
}

// => Watch
watch(
	() => props.disabled,
	() => {
		if (props.disabled) model.value.search = "";
	}
);
onMounted(() => {
	if (props.pagination) currentPage.value = props.pagination.currentPage;
});

return (_ctx: any,_cache: any) => {
  const _component_base_button = _resolveComponent("base-button")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_base_pagination = _resolveComponent("base-pagination")!
  const _component_card = _resolveComponent("card")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_card, {
    class: _normalizeClass(props.cardClass)
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("h2", _hoisted_2, _toDisplayString(props.tittle), 1),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_el_popover, {
            placement: "top",
            content: "Recargar",
            "show-after": 700,
            trigger: "hover"
          }, {
            reference: _withCtx(() => [
              (props.btn)
                ? (_openBlock(), _createBlock(_component_base_button, {
                    key: 0,
                    type: "default",
                    onClickCapture: _cache[0] || (_cache[0] = ($event: any) => (
								_ctx.$emit('updateData', {
									pagination: getPag(),
									typeSelect: model.value.selectValue,
								})
							)),
                    style: {"height":"43px"},
                    disabled: props.disabled
                  }, {
                    default: _withCtx(() => [
                      _hoisted_4
                    ]),
                    _: 1
                  }, 8, ["disabled"]))
                : _createCommentVNode("", true),
              _hoisted_5
            ]),
            _: 1
          })
        ]),
        (props.select === true)
          ? (_openBlock(), _createBlock(_component_el_select, {
              key: 0,
              size: "small",
              class: "select-primary pagination-select mr-2",
              modelValue: model.value.selectValue,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((model.value.selectValue) = $event)),
              placeholder: "",
              onChange: _cache[2] || (_cache[2] = ($event: any) => (
					_ctx.$emit('updateData', {
						pagination: getPag(1),
						typeSelect: model.value.selectValue,
					})
				))
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.selectArray, (item) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    class: "select-primary",
                    key: item.value,
                    label: item.label,
                    value: item.value
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_6, [
          (props.filter)
            ? _withDirectives((_openBlock(), _createBlock(_component_el_input, {
                key: 0,
                onInput: _cache[3] || (_cache[3] = ($event: any) => (
						_ctx.$emit('updateInputData', {
							pagination: getPag(),
							typeSelect: model.value.selectValue,
						})
					)),
                modelValue: model.value.search,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((model.value.search) = $event)),
                size: "large",
                placeholder: "Buscar",
                "input-style": "height: 45px",
                "prefix-icon": _unref(Search),
                ref_key: "buttonRef",
                ref: buttonRef
              }, null, 8, ["modelValue", "prefix-icon"])), [
                [_unref(vClickOutside), onClickOutside]
              ])
            : _createCommentVNode("", true)
        ]),
        _createVNode(_component_el_select, {
          size: "small",
          class: "select-primary pagination-select mr--2",
          modelValue: _unref(pagination).perPage,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(pagination).perPage) = $event)),
          placeholder: "Per page",
          onChange: onChangeLimit
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(pagination).perPageOptions, (item) => {
              return (_openBlock(), _createBlock(_component_el_option, {
                class: "select-primary",
                key: item,
                label: item,
                value: item
              }, null, 8, ["label", "value"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"]),
        (props.information)
          ? (_openBlock(), _createBlock(_component_el_popover, {
              key: 1,
              ref_key: "popoverRef",
              ref: popoverRef,
              placement: "top-start",
              width: 200,
              trigger: "hover",
              "show-after": 10,
              triggerKeys: []
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  innerHTML: props.informationLabel
                }, null, 8, _hoisted_7)
              ]),
              reference: _withCtx(() => [
                _createVNode(_component_el_button, {
                  class: "ml-3",
                  icon: _unref(InfoFilled),
                  size: "small",
                  circle: ""
                }, null, 8, ["icon"])
              ]),
              _: 1
            }, 512))
          : _createCommentVNode("", true)
      ]),
      _withDirectives((_openBlock(), _createBlock(_component_el_table, _mergeProps({
        data: _unref(pagedData),
        "row-key": "id",
        "header-row-class-name": "thead-light",
        border: "",
        "table-layout": props.tableLayout,
        style: {"width":"100%"}
      }, props.tableProps, {
        onRowClick: _cache[6] || (_cache[6] = (row, col, e) => emits('row-click', {row, col, e}))
      }), {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.tableData?.th, (column, index) => {
            return (_openBlock(), _createBlock(_component_el_table_column, _mergeProps({
              sortable: "",
              key: column.value
            }, column, {
              prop: column.value,
              label: column.text,
              "min-width": column?.width ?? 250
            }), {
              default: _withCtx((scope) => [
                _createElementVNode("div", null, [
                  _createVNode(ColumnProp, {
                    scope: scope,
                    column: column,
                    index: index
                  }, null, 8, ["scope", "column", "index"])
                ])
              ]),
              _: 2
            }, 1040, ["prop", "label", "min-width"]))
          }), 128)),
          (__props.showOptions)
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 0,
                label: "",
                "min-width": "50",
                "class-name": "p-0 cell-text-align",
                "label-class-name": "p-0",
                fixed: "right"
              }, {
                default: _withCtx((scope) => [
                  _createVNode(_component_el_popover, {
                    width: "150",
                    placement: "left",
                    trigger: "click",
                    "popper-style": "padding: 0;"
                  }, {
                    reference: _withCtx(() => [
                      _hoisted_8
                    ]),
                    default: _withCtx(() => [
                      (!__props.hideDefaultOptions)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                            _createElementVNode("button", {
                              class: "bg-white p-2 text-left fs-7 border-0 w-100 text-start dropdown-control-menu__item",
                              onClick: ($event: any) => (emits('edit', scope.row))
                            }, _hoisted_13, 8, _hoisted_10)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 16, ["data", "table-layout"])), [
        [_directive_loading, props.load]
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("p", _hoisted_17, " Muestra " + _toDisplayString(_unref(from) + 1) + " hasta " + _toDisplayString(_unref(to)) + " de " + _toDisplayString(_unref(total)) + " entradas ", 1)
          ]),
          _createVNode(_component_base_pagination, {
            class: "pagination-no-border",
            modelValue: currentPage.value,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((currentPage).value = $event)),
            "per-page": _unref(pagination).perPage,
            total: _unref(total),
            onUpdateData: _cache[8] || (_cache[8] = ($event: any) => (
						_ctx.$emit('updateData', {
							pagination: getPag(),
							typeSelect: model.value.selectValue,
						})
					))
          }, null, 8, ["modelValue", "per-page", "total"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["class"]))
}
}

})